import { memo } from 'react';

import { Avatar } from '@air/primitive-avatar';
import { formatInitials } from '@air/utilities';

import { useAccountContext } from '~/providers/AccountProvider';
import { formatFullName } from '~/utils/formatFullName';

export const AccountInformation = memo(() => {
  const { data } = useAccountContext();
  const { lastName, firstName, avatar, id } = data || {};
  const initials = formatInitials(firstName, lastName);

  if (!data) {
    return null;
  }

  return (
    <div className="flex items-center gap-2" data-testid="PUBLIC_TOP_BAR_ACCOUNT_NAME">
      <Avatar colorSeed={id} size={24} src={avatar} text={initials} />
      <div className="font-medium ads:text-secondary text-12 text-gray-11" data-testid="PUBLIC_PAGE_ACCOUNT_NAME_TEXT">
        {formatFullName(firstName, lastName)}
      </div>
    </div>
  );
});

AccountInformation.displayName = 'AccountInformation';
